export const caZipCodeRegExp = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

export const usZipCodeRegExp = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

export function escapeSpecialCharacters(str) {
  return str.replace(/[^a-zA-Z0-9]/g, '\\$&');
}



// WEBPACK FOOTER //
// ./src/utils/regExp.js